<template>
  <transition name="fade">
    <div class="component-toaster" v-if="toaster.length > 0">
      <transition-group name="toaster" class="toaster" tag="div">
        <div
          class="toaster__item"
          v-for="toast in toaster"
          :key="toast.time"
          @click="clearToaster(toast.time)"
        >
          <div class="toaster__icon">
            <span>!</span>
          </div>
          <div class="toaster__text">
            <p v-html="$t(toast.error)"></p>
          </div>
        </div>
      </transition-group>
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  mounted() {
    this.checkToasterLifecycle();
  },
  updated() {
    this.checkToasterLifecycle();
  },
  computed: {
    ...mapGetters('app', ['getToaster']),
    toaster() {
      return this.getToaster || [];
    },
  },
  methods: {
    ...mapActions('app', ['clearToaster']),
    checkToasterLifecycle() {
      if (this.getToaster) {
        _.forEach(this.getToaster, toast => {
          if (toast.time > Date.now() + 5) {
            this.clearToaster(toast.time);
          } else {
            window.setTimeout(() => {
              this.clearToaster(toast.time);
            }, 10000);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.toaster-enter-active,
.toaster-leave-active,
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  opacity: 1;
}
.toaster-enter,
.toaster-leave-to,
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
